import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack,
} from '@mui/material';
import moment from 'moment';
import {
  Form, useTranslate,
} from 'react-admin';
import type { ExpiryTimeGranularity } from '@x-guard/xgac-types/xgac';
import { ExpiryDateDisplay } from './ExpiryDateDisplay';
import { DocumentaryProofInputPreview } from './DocumentaryProof';

export type RenewNowFormValues = {
  lastInspectionDate: string;
  expiryDate: string;
  document?: File;
};
export const RenewNowModal = (props: {
  open: boolean;
  onClose: () => void;
  onBack?: () => void;
  onSubmit: (values: RenewNowFormValues) => Promise<void>;
  timeGranularity?: ExpiryTimeGranularity;
  startDateSource?: string;
  expiryDateSource?: string;
  startDateLabel: string;
  expiryDateLabel: string;
  helperText: string;
  title: string;
  hasDocumentaryProofField?: boolean;
}) => {

  const translate = useTranslate();
  const startDateSource = props.startDateSource ?? 'lastInspectionDate';
  const expiryDateSource = props.expiryDateSource ?? 'expiryDate';
  const defaultValues = {
    [startDateSource]: moment().format('YYYY-MM-DD'),
    [expiryDateSource]: props.timeGranularity
      ? moment().add(props.timeGranularity.value, props.timeGranularity.type).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD'),
  };
  const handleSubmit = async (values: Record<string, unknown>) => {

    await props.onSubmit({
      lastInspectionDate: values[startDateSource] as string,
      expiryDate: values[expiryDateSource] as string,
      document: values.document as File | undefined,
    });

  };
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
      <DialogTitle>{translate(props.title)}</DialogTitle>
      <DialogContent>
        <Form
          id="renew-now-form"
          defaultValues={defaultValues}
          onSubmit={handleSubmit}
        >
          <Stack spacing={2} sx={{ mt: 3 }}>
            <ExpiryDateDisplay
              startDateSource={startDateSource}
              expiryDateSource={expiryDateSource}
              timeGranularity={props.timeGranularity}
              startDateLabel={props.startDateLabel}
              expiryDateLabel={props.expiryDateLabel}
              helperText={translate(props.helperText)}
            />
            {props.hasDocumentaryProofField && (
              <DocumentaryProofInputPreview
                source="document"
                imageStyle={{
                  height: '600px',
                  marginBottom: '10px',
                  objectPosition: 'left',
                }}
                pdfStyle={{
                  height: '800px', marginBottom: '10px',
                }}
              />
            )}
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions>
        {props.onBack && (
          <Button onClick={props.onBack}>{translate('ra.action.back')}</Button>
        )}
        <Button onClick={props.onClose}>{translate('ra.action.cancel')}</Button>
        <Button type="submit" form="renew-now-form" variant="contained">
          {translate('ra.action.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );

};
